import styled from 'styled-components'

type ServicesContainerProps = {
  darkMode?: boolean
}

export const ServicesContainer = styled.section<ServicesContainerProps>`
  display: flex;
  gap: 70px;
  width: 100%;
  max-width: 1170px;

  .description {
    white-space: pre-line;
    flex: 1;
  }

  @media (max-width: 1180px) {
    padding: 0 16px;
  }
  @media screen and (max-width: 1000px) {
    flex-direction: column;

    .button-container {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`

export const DescriptionContainer = styled.div<ServicesContainerProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 40px;

  @media (min-height: 750px) {
    .description {
      font-size: 20px;
    }
  }

  @media (max-width: 791px) {
    .description {
      font-size: 16px;
      line-height: 24px;
    }
  }
`

export const ServiceListingContainer = styled.div<ServicesContainerProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  gap: 48px;
`
export const DescribedServiceContainer = styled.div<ServicesContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
